import { FunctionComponent, useEffect } from 'react';

import {
  EndSessionRequest,
  IPublicClientApplication,
} from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

import localStorageService from '../../../shared/services/local-storage/local-storage.service';

const logout = async (
  instance: IPublicClientApplication,
  logoutRequest: EndSessionRequest
): Promise<void> => {
  localStorageService.clearAppState();
  await instance.logoutRedirect(logoutRequest);
};

const Logout: FunctionComponent = () => {
  const { instance } = useMsal();

  const logoutRequest = {
    account: instance.getAllAccounts()[0],
  };

  useEffect(() => {
    logout(instance, logoutRequest);
  }, [logout]);

  return <></>;
};

export default Logout;
